import React from 'react';
import _ from 'lodash'

import { upperFirst } from '@/utils';

class BaseManager extends React.Component {

	keyName = "id";
	
	getKey = () => {
		return this.attrs('$', 'keyName');
	}

	baseWhereInAttrs = ['props', '']

	attrs = (customer, typer, whereIn=this.baseWhereInAttrs) => BaseManager.attrs(this, customer, typer, whereIn)

	static attrs = (_this, customer, typer, whereIn=['props', '']) => {
		/*_this.temp[customer.replace(/\$/g, upperFirst(typer))] || _this.props[customer.replace(/\$/g, upperFirst(typer))] || _this[customer.replace(/\$/g, upperFirst(typer))]*/
		let result;
		whereIn.some(val=>{
			const handlerName = customer ? customer.replace(/^(.+)\$/g, "$1"+upperFirst(typer)).replace(/^\$/, typer) : typer;
			const path = (val ? val+"." : "")+handlerName;
			//result = val ? _this[val] && _this[val][handlerName] : _this[handlerName];
			result = _.get(_this, path);
			return !!result;
		})
		return result;
	}

}

export default BaseManager
